export const CFO_TOOL_REGISTRY = {
  'tool-fpa-1': {
    title: 'E2E损益表',
    component: () => import('./ToolFpaPlStatement.vue')
  },
  'tool-fpa-2': {
    title: '月度毛利率预测',
    component: () => import('./ToolFpaGmForecast.vue')
  },
  'tool-fpa-3': {
    title: 'What-if情景模拟',
    component: () => import('./ToolFpaWhatIf.vue')
  },
  'tool-fa-1': {
    title: '毛利率影响因素分析',
    component: () => import('./ToolFaSensitivity.vue')
  },
  'tool-fa-2': {
    title: '采购价格差异追踪',
    component: () => import('./ToolFaPriceVariance.vue')
  },
  'tool-fa-3': {
    title: '预测偏差回溯',
    component: () => import('./ToolFaForecastBacktest.vue')
  },
  'tool-ctrl-1': {
    title: '月结关账看板',
    component: () => import('./ToolCtrlClosing.vue')
  },
  'tool-ctrl-2': {
    title: '数据可信度矩阵',
    component: () => import('./ToolCtrlDataTrust.vue')
  },
  'tool-ctrl-3': {
    title: 'E2E口径一致性校验',
    component: () => import('./ToolCtrlConsistency.vue')
  },
  'tool-track-1': {
    title: '现金流监控驾驶舱',
    component: () => import('./ToolTrackCashflow.vue')
  },
  'tool-track-2': {
    title: '预算执行率热力图',
    component: () => import('./ToolTrackBudgetHeatmap.vue')
  },
  'tool-track-3': {
    title: '营运资金分析',
    component: () => import('./ToolTrackWorkingCapital.vue')
  }
}

export const CFO_TOOL_LIST = [
  { id: 'tool-fpa-1', name: 'E2E损益表', badge: 'FPA', icon: 'el-icon-s-grid' },
  { id: 'tool-fpa-2', name: '月度毛利率预测', badge: 'FPA', icon: 'el-icon-data-line' },
  { id: 'tool-fpa-3', name: 'What-if情景模拟', badge: 'FPA', icon: 'el-icon-s-operation' },
  { id: 'tool-fa-1', name: '毛利率影响因素分析', badge: 'FA', icon: 'el-icon-magic-stick' },
  { id: 'tool-fa-2', name: '采购价格差异追踪', badge: 'FA', icon: 'el-icon-sort' },
  { id: 'tool-fa-3', name: '预测偏差回溯', badge: 'FA', icon: 'el-icon-time' },
  { id: 'tool-ctrl-1', name: '月结关账看板', badge: 'CTRL', icon: 'el-icon-date' },
  { id: 'tool-ctrl-2', name: '数据可信度矩阵', badge: 'CTRL', icon: 'el-icon-s-grid' },
  { id: 'tool-ctrl-3', name: 'E2E口径一致性校验', badge: 'CTRL', icon: 'el-icon-circle-check' },
  { id: 'tool-track-1', name: '现金流监控驾驶舱', badge: 'TRACK', icon: 'el-icon-odometer' },
  { id: 'tool-track-2', name: '预算执行率热力图', badge: 'TRACK', icon: 'el-icon-s-data' },
  { id: 'tool-track-3', name: '营运资金分析', badge: 'TRACK', icon: 'el-icon-pie-chart' }
]
